import React from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import Button from '../V2/Button/Button';
import Logo from '../Icons/Logo';

/**
 * Errore generico.
 */
export default function ErrorPage({
  image, title, message, actionLabel, onActionClick, asPage,
}) {
  const className = cns('error-page', {
    'error-page--inside': !asPage,
  });

  return (
    <div className={className}>
      <div className="error-page__main error-page__main--error-page">
        <div className="error-page__empty" />
        {image}
        <div className="error-page__message">
          <p className="error-page__message-title">
            {title}
          </p>
          <p className="error-page__message-message">
            {message}
          </p>
          {actionLabel && onActionClick
            && (
              <div className="error-page__message-action">
                <Button primary emphasis={Button.Emphasis.HIGH} onClick={onActionClick}>
                  {actionLabel}
                </Button>
              </div>
            )}
        </div>
        <div className="error-page__empty" />
      </div>
      {asPage && (
        <div className="error-page__fixedfooter">
          <div className="error-page__footer">
            <Logo className="error-page__logo error-page__logo--unexpected" />
          </div>
        </div>
      )}
    </div>
  );
}

ErrorPage.propTypes = {
  /**
Immagine del componente
  */
  image: PropTypes.node.isRequired,

  /**
Titolo.
  */
  title: PropTypes.string.isRequired,

  /**
Messaggio. Il messaggio può essere una semplice stringa o un componente più complesso.
  */
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,

  /**
Etichetta del messaggio della action.
  */
  actionLabel: PropTypes.string,

  /**
Callback della action.
  */
  onActionClick: PropTypes.func,

  /**
Indica se mostrare il componente "come pagina singola".

Se il componente deve essere inserito in una `Card`, `Modal` o altro, usare `asPage=false`.
  */
  asPage: PropTypes.bool,
};

ErrorPage.defaultProps = {
  asPage: true,
  actionLabel: undefined,
  onActionClick: undefined,
};
